import React from "react";
import { Nav } from "shards-react";

import { UserContext } from "../../../backend/userContext";
import getNavItems from "../../../data/sidebar-nav-items";
import SidebarNavItem from "./SidebarNavItem";

class SidebarNavItems extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);

    this.state = {
      navItems: [],
    };
  }

  componentDidMount() {
    this.setState({ navItems: getNavItems(this.context.user) });
  }

  render() {
    return (
      <div className="nav-wrapper">
        <Nav className="nav--no-borders flex-column">
          {this.state.navItems.map((item, idx) => (
            <SidebarNavItem
              key={idx}
              item={item}
              toggleSideBar={this.props.toggleSideBar}
            />
          ))}
        </Nav>
      </div>
    );
  }
}

export default SidebarNavItems;
